import DemystLogoWhite from "../../../assets/svg/DemystLogoWhite.svg";

import { linksConstants } from "../../../../constants/linksConstants";
import { card } from "../../../datasets/landingpages/webinarregistration/card";
import Link from "next/link";

export const WebinarCard = ({ loading, post, showTable }) => {
  return (
    <section className="webinar_card-summary_background">
      <div className="webinar_card-summary_card">
        <Link href={linksConstants.HOME}>
          <img className="webinar_card-logo" src={DemystLogoWhite.src} alt="Demyst Logo" />
        </Link>
        {(loading || typeof post === "undefined") && <div className="webinar_card-spinner" />}
        {!loading && typeof post !== "undefined" && (
          <>
            <h1 className="webinar_card-header">{post.title}</h1>
            <div className="webinar_card-summary" dangerouslySetInnerHTML={{ __html: post.text }} />
            {post?.presenters?.length > 0 &&
              post?.presenters?.map(presenter => (
                <section key={presenter.presenter_name} className="webinar_card-presenter">
                  <img src={presenter.presenter_image.src} alt="Presenter" />
                  <div className="webinar_card-presenter_info">
                    <p>{presenter.presenter_role || card.presenterdby}</p>
                    <p>{`${presenter.presenter_name}, ${presenter.presenter_description}`}</p>
                  </div>
                </section>
              ))}
            {showTable && (
              <section className="webinar_card-table">
                <p className="webinar_card-table_header">{card.upcoming}</p>
                {post.upcoming_topics.map((position, index) => (
                  <p key={`webinar_card-table-${index}`}>{position.topic_name}</p>
                ))}
                <div className="webinar_card-table_footer" />
              </section>
            )}
          </>
        )}
      </div>
    </section>
  );
};
